/* eslint-disable react/function-component-definition */
import React, { useImperativeHandle, useState, useRef } from 'react';
import { getSubscribe } from '$/common/utils/subscribeUtil';
import { message } from '$/components/Message';
import { useLanguageStore } from '$/store/languageStore';
import Input from '$/components/base/Input';
import ConfirmModal, { ConfirmModalRef } from '$/components/ConfirmModal';
import { checkMeiyeAmount } from '$/api/server';
import { useOfficialStore } from '$/store/useOfficialStore';
import { useNetwork } from 'ahooks';
import SuccessExchange from './SuccessExchange';
import type { SuccessExchangeRef } from './SuccessExchange';

import styles from './index.module.scss';

export interface ExchangeCodeRef {
  open: () => void;
}

interface ExchangeCodeProps {
  zIndex?: number;
}

/** 渲染会员兑换码弹窗，并允许订阅主弹窗场景显式抬高层级。 */
const ExchangeCodeModal: React.ForwardRefRenderFunction<ExchangeCodeRef, ExchangeCodeProps> = (props, ref) => {
  const { zIndex } = props;
  const [value, setValue] = useState('');
  const confirmModalRef = useRef<ConfirmModalRef>(null);
  const successEchangeRef = useRef<SuccessExchangeRef>(null);
  const languageStore = useLanguageStore((state) => state.languageStore);
  const networkState = useNetwork();
  const loadSubscribeInfo = useOfficialStore(
    (state) => state.loadSubscribeInfo,
  );
  const handleExchangeCode = async () => {
    try {
      const instance = await getSubscribe();
      // 3、通过 entranceBizCode 获取（通常由产品在订阅后台配置后同步给前端开发）
      if (!networkState.online) {
        message.error('network_error');
        return;
      }
      if (!instance) {
        // message.error(languageStore.smartcatTranslationText((v) => v.network_error));
        return;
      }
      const res = await instance.exchangeRedeemCode({
        redeemCode: value,
        device: 3, // 此处设备鸿蒙
      });
      if (res) {
        successEchangeRef.current?.open(res.redeemDuration);
        checkMeiyeAmount?.();
        loadSubscribeInfo?.();
        setValue('');
      }
    } catch (err: any) {
      if (err.message) {
        // successEchangeRef.current?.open(1);
        message.error(err.message);
      }
      console.error('Failed to fetch product list:', err);
    } finally {
    //   setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    open: () => {
      confirmModalRef.current?.openModal();
    },
  }));
  const tips = [languageStore.smartcatTranslationText((v) => v.UID_Echange), languageStore.smartcatTranslationText((v) => v.Exchange_right_services), languageStore.smartcatTranslationText((v) => v.Expiration_time), languageStore.smartcatTranslationText((v) => v.Rule), languageStore.smartcatTranslationText((v) => v.Rule2)];

  return (
    <ConfirmModal
      ref={confirmModalRef}
      title={languageStore.smartcatTranslationText((v) => v.member_redemption_code)} // "会员兑换码"
      disabled={!value.trim()}
      confirmText={languageStore.smartcatTranslationText((v) => v.Redem)}
      onConfirm={handleExchangeCode}
      onClose={() => {
        setValue('');
      }}
      buttonStyle={{ margin: '0 18px 18px', width: 'auto' }}
      zIndex={zIndex}
    >
      <div className={styles['exchange-code-container']}>
        <Input
          placeholder={languageStore.smartcatTranslationText((v) => v.please_enter_the_member_redemption_code_case_sensitive)}// "please_enter_the_member_redemption_code_case_sensitive
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          inputStyle={{ fontSize: '14px' }}
          style={{ height: '36px' }}

        />
        <div className={styles['exchange-tip-text']}>
          <div>
            {languageStore.smartcatTranslationText((v) => v.Redemption_Instructions)}
            ：
          </div>
          {(tips || []).map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              {index + 1}
              .
              {item}
            </div>
          ))}
        </div>
      </div>
      <SuccessExchange
        ref={successEchangeRef}
        onClose={() => {
          confirmModalRef.current?.closeModal();
        }}
        zIndex={zIndex === undefined ? undefined : zIndex + 1}
      />
    </ConfirmModal>
  );
};
export default React.forwardRef(ExchangeCodeModal);
